import { Box, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../../common/Context";
import LoadingWheel from "../../../../common/LoadingWheel";
import { useTranslation } from "react-i18next";
import { white } from "../../../../../theme/colours";

const TeamBanner = (props) => {
  const { t } = useTranslation("SafeRoads");
  const { team, sponsors = {}, banner } = props;
  const { mobileView, tabletView } = useContext(GlobalContext);

  const [sponsorList, setSponsorList] = useState([]);

  const screen = mobileView ? "Mobile" : tabletView ? "Tablet" : "Desktop";

  const isEven = (number) => number % 2 === 0;

  const isHorizontal = () => {
    if (tabletView) return true;

    let length = sponsorList.length;
    if (!isEven(length)) length++;

    return isEven(length / 2);
  };

  useEffect(() => {
    if (!sponsors) return;

    setSponsorList(sponsors[team.id] || []);
  }, [sponsors, team]);

  const containerStyle = {
    backgroundImage: banner
      ? `url(${banner})`
      : `url(images/leaderboardBanners/TeamBanner-${screen}.webp)`,
    width: mobileView || tabletView ? "100%" : "50%",
    height: "100%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    justifyContent: tabletView ? "space-around" : "center",
    alignItems: "center",
    borderRadius: "0.5rem",
    p: `1.5rem ${mobileView ? 1 : tabletView ? 2 : 4}rem`,
    mb: (mobileView || tabletView) && "1.5rem",
    flexDirection: isHorizontal() && !tabletView ? "column" : "row",
  };

  const teamNameStyle = {
    color: white,
    width: isHorizontal() && !tabletView ? "100%" : "40%",
    textAlign: isHorizontal() && "center",
    m: "0.75rem",
  };

  const teamTextStyle = {
    textTransform: "uppercase",
    fontSize: "0.875rem",
    fontWeight: 600,
    mb: "0.25rem",
  };

  const nameTextStyle = {
    fontSize: "1.75rem",
    lineHeight: 1,
  };

  const sponsorLogoBox = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    width: isHorizontal() ? "100%" : "50%",
  };

  const sponsorLogoStyle = {
    width: isHorizontal() ? "20%" : "45%",
    height: "auto",
    "&:first-child": {
      ml: 0,
    },
    textAlign: "center",
    color: white,
    fontWeight: 500,
    lineHeight: 1.25,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const DEFAULT_ML_H = "calc(20% / 3)";
  const sponsorLogosHorizontal = {
    ...sponsorLogoStyle,
    ml: DEFAULT_ML_H,
    "&:nth-child(-n+4)": {
      mb: "0.5rem",
    },
    "&:nth-child(4)": {
      ml:
        tabletView && sponsorList.length < 7 && sponsorList.length > 4
          ? 0
          : DEFAULT_ML_H,
      mb:
        tabletView && sponsorList.length < 7 && sponsorList.length > 4
          ? "0rem"
          : "0.5rem",
    },
    "&:nth-child(5)": {
      ml:
        tabletView && sponsorList.length < 7 && sponsorList.length > 4
          ? DEFAULT_ML_H
          : 0,
    },
  };

  const sponsorLogosVertical = (index) => {
    let mod = {};
    let len = sponsorList.length;
    if (len > 2 && index >= (isEven(len) ? len - 2 : len - 1)) {
      mod = { mb: 0 };
    }

    return {
      ...sponsorLogoStyle,
      mb: "0.5rem",
      ...mod,
      "&:nth-child(2n)": {
        ml: sponsorList.length > 2 && "10%",
      },
    };
  };

  const noSponsorTextStyle = {
    color: white,
    fontSize: "0.875rem",
    textAlign: "center",
    lineHeight: 1.75,
  };

  return sponsorList ? (
    <Box sx={containerStyle}>
      <Box sx={teamNameStyle}>
        <Typography sx={teamTextStyle}>Team</Typography>
        <Typography sx={nameTextStyle} variant="h2">
          {team.name}
        </Typography>
      </Box>
      <Box sx={sponsorLogoBox}>
        {sponsorList.length ? (
          sponsorList.map((sponsor, index) =>
            sponsor.logo ? (
              <Box
                key={index}
                component="img"
                src={sponsor.logo}
                sx={
                  isHorizontal()
                    ? sponsorLogosHorizontal
                    : sponsorLogosVertical(index)
                }
              />
            ) : (
              <Typography
                key={index}
                sx={
                  isHorizontal()
                    ? sponsorLogosHorizontal
                    : sponsorLogosVertical(index)
                }>
                {sponsor.name}
              </Typography>
            ),
          )
        ) : (
          <Typography sx={noSponsorTextStyle}>{t("driveSafe")}</Typography>
        )}
      </Box>
    </Box>
  ) : (
    <Box width="50%">
      <LoadingWheel width={5} />
    </Box>
  );
};

export default TeamBanner;
